import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BusyContainer, Checkbox, IconButton } from '..';
import { translate ,getLanguages} from '../../services';
import { PropTypes } from 'prop-types';
import {
  exportDispatcher, exportState, combineStates, productState, priceState, combineDispatchers,
  productsDispatcher, identityState, currentNodeState, siteSettingsState,cartState
} from '../../store';
 
import { getAccessories, getProductDescription, getProductid, validateResponse ,assignmentDecision, getAssignedValue, deflateModelVariables} from '../../util';
import { closePopup } from '../../../style/images';
import { Box, IconButton as MuiIconButton } from '@mui/material';
import classNames from 'classnames';
import { DropdownList } from 'react-widgets';
import { getNSTPrice } from '../../util';
import deepStrictEqual from 'deep-strict-equal';
 
 
export class ExportCartPanelComponent extends Component {
  constructor() {
    super();
    this.onExport = this.onExport.bind(this);
    this.getProduct = this.getProduct.bind(this);
    this.ensureAllProductsAreLoaded = this.ensureAllProductsAreLoaded.bind(this);
    this.state = {
      loading: false,
      checkBox: false,
      isBusy:false,
      tenderText: "10"
    };
  }
 
  componentDidMount() {
    this.ensureAllProductsAreLoaded();
  }
 
  ensureAllProductsAreLoaded() {
    // ensure that all products are available
    const { cartItems, products } = this.props;
    if (!cartItems) {
      return;
    }
    const unmappedProducts = cartItems.map(item => [
      item.name, ...item.configuration && item.configuration.bomComponents
        ? item.configuration.bomComponents.map(c => c.component)
        : getAccessories(item)]).flat().filter(name => !products[name]);
    if (unmappedProducts.length && unmappedProducts[0]) {
      this.setState({ loading: true }, () => this.props.getProducts(unmappedProducts)
        .then(_ => this.setState({ loading: false })));
    }
  }
 
  getProduct(product) {
    const { prices } = this.props;
    if (!product || !prices[product.name]) {
      return product;
    }
    return { ...product, ...prices[product.name] };
  }
 
  getCurrency() {
    const { prices, cartItems, user, siteSettings } = this.props;
    // return cartItems.firstOrDefault().name && prices[cartItems.firstOrDefault().name] &&
    //   prices[cartItems.firstOrDefault().name].rateUnit ? prices[cartItems.firstOrDefault().name].rateUnit : 'EUR' ;
    return siteSettings.currency || cartItems.firstOrDefault().name && prices[cartItems.firstOrDefault().name] &&
      prices[cartItems.firstOrDefault().name].rateUnit || user.currency || 'EUR';
  }
 
  dummyCode(item,variableName)
  {
    let checkingArray =[];
    if(variableName == "SEMI_TERM_INF")
    {
      console.log("Inside Dummy Code");
    }
    checkingArray[0]="Hello";
    return checkingArray;
  }
 
  onExport = async () => {
    const { cartItems, exportFileTypes, products, user, currentNode,siteSettings,cart,materialCorrection ,prices} = this.props;
    const { customExportTemplate } = currentNode.customProperties;
    const currency = this.getCurrency();
     let itemCount=0;
    const isReadyAssembled = ( user.country.indexOf( 'CBOL' ) > -1 || user.country.indexOf( 'Cbol' ) > -1 ||
      user.authenticationType == 'CBOL' ) && siteSettings.createSupercodeInSap;
    //ga4
    let cartItemsList = [];
    cartItems && cartItems.forEach((a, idx) => { cartItemsList[idx] = a.code })
 
    dataLayer.push({
      'event': 'export_cart_item',
      event_action: 'export_cart',
      event_label: [...new Set(cartItemsList)].join(';'),
      event_instance: this.props.siteSettings.properties.GaInstance,
      event_country: this.props.siteSettings.properties.GaCountry,
      location_url: window.location.href
    })
    if (!exportFileTypes || this.busy) {
      return;
    }
    for (let type in exportFileTypes) {
      if (exportFileTypes[type] && (type === 'xlsx' || type == 'Excel for CBOL')) {
        const exportItemsXLS = cartItems.map((item) => {
  itemCount+=1;
          if(item.code.startsWith('V')){
            item.superCode=''
          }
 
          const onExport=true;
          const price=getNSTPrice(item,prices,false,false,false,false,false,'listPrice',false,false,onExport)*siteSettings?.properties?.priceFactor;
          item.description = getProductDescription(item);
          item.NST_description=item.NST_description?item.NST_description:item.superCodeLSO?item.fgProduct && item.fgProduct[0] && item.fgProduct[0].Description:'';
          item.nstPrice=price;
          item.assemblyOption = '组装';
          item.itemNumber=itemCount;
          item.deliveryOption=item.deliveryOption;
          if(item.superCode && item.superCode=='1SDX'){delete item.superCode}
          item.VATlistPrice=this.props.prices[item.name]?.listPrice*siteSettings?.properties?.priceFactor;
          item.noteByUser=item.noteByUser!==null && typeof(item.noteByUser) !== "undefined"?item.noteByUser:'';
          if ( siteSettings.createSupercodeInSap && item.superCode != undefined && isReadyAssembled && user.country == siteSettings.properties.userCountry ) {
            const accessories = getAccessories( item );
            item.children = accessories.map( ( accessoryCode ) => products[accessoryCode] ).map( this.getProduct );
            item.description = getProductDescription( item,'' );
 
            const missingBomItems = item.configuration && item.configuration.assignments.filter( assign => assign.key === null )
              .map( c => products[c.value] ).map( this.getProduct );
            missingBomItems && missingBomItems.forEach( bomItem => {
              item.children.push( bomItem );
            } )
            // Adding the quantity from the import accessories if the item is imported and not configured or if configured
            // then updating the quantity from main product amount
            if ( item.importAccessories && item.importAccessories.length > 0 ) {
              item.children = item.children.map( children => ( {
                ...children,
                amount: Number( item.importAccessories.find( acc => acc.accessoryCode === children.code )?.quantity ) || 0
              } ) )
                .filter( c => c.amount > 0 );
            } else {
              item.amount=item.amount?item.amount:1;
              item.children = item.children.map( children => ( {
                ...children,
                amount: Number( children?.quantity * item.amount || item.amount || 1 )
              } ) );
            }
            return item;
          }
          else{
          item.description = getProductDescription(item);
          const accessories=getAccessories(item)
          const accessorylength=accessories && accessories.length
          if(accessorylength==0 && item.superCodeLSO){
            item.superCodeLSO=item.code
          }
          if (item.configuration && item.configuration.bomComponents && item.configuration.bomComponents.length) {
            item.children = item.configuration.bomComponents.filter(bom => products[bom.component] !== null
              && products[bom.component] !== undefined).map(c => products[c.component]).map(this.getProduct);
            item.children = item.children.map(children => {
              if(item.code?.startsWith('V')){
                return{...children,
                  amount : Number( item.configuration.bomComponents.filter(bom => bom.component == children.code && bom.quantity)
                  .firstOrDefault()?.quantity * item.amount || item.amount || 1 ),
                  itemNumber:itemCount,
                  VATlistPrice:this.props.prices[children.name]?.listPrice*siteSettings?.properties?.priceFactor,
                  properties:[]
   
              }}
              else{
                return{...children,
                  amount : Number( item.configuration.bomComponents.filter(bom => bom.component == children.code && bom.quantity)
                  .firstOrDefault()?.quantity * item.amount || item.amount || 1 ),
                  itemNumber:itemCount,
                  VATlistPrice:this.props.prices[children.name]?.listPrice*siteSettings?.properties?.priceFactor,
                  configuredacc:item.bom?item.bom?.any(b=> b?.name==children.name):false,
                  properties:[]
   
              }
              }
              }
              );
          } else {
            const accessories = getAccessories( item,false,onExport );
            item.children = accessories.map(( accessoryCode ) => products[accessoryCode]).map(this.getProduct);
            const missingBomItems = item.configuration && item.configuration.assignments.filter(assign => assign.key === null)
              .map(c => products[c.value]).map(this.getProduct);
            missingBomItems && missingBomItems.forEach(bomItem => {
              item.children.push(bomItem);
            })
            // Adding the quantity from the import accessories if the item is imported and not configured or if configured
            // then updating the quantity from main product amount
            if (item.importAccessories && item.importAccessories.length > 0) {
              item.children = item.children.map(children => {
                if(item.code?.startsWith('V')){  
                return ({...children,
                amount: Number( item.importAccessories.find(acc => acc.accessoryCode === children.code)?.quantity ) || 0,
                itemNumber:itemCount,
                VATlistPrice:this.props.prices[children.name]?.listPrice*siteSettings?.properties?.priceFactor,
              })}
else{
                return ({...children,
                  amount: Number( children?.quantity * item.amount || item.amount ),
                  itemNumber:itemCount,
                  configuredacc:item.bom?item.bom?.any(b=> b?.name==children.name):false,
                  VATlistPrice:this.props.prices[children.name]?.listPrice*siteSettings?.properties?.priceFactor
                })
              }
               
              })
 
                .filter(c => c.amount > 0);
            } else {
              item.children = item.children.map(children => {
                if(item.code?.startsWith('V')){
                return ({...children,
                amount: Number( children?.quantity * item.amount || item.amount ),
                itemNumber:itemCount,
                VATlistPrice:this.props.prices[children.name]?.listPrice*siteSettings?.properties?.priceFactor
              })}
            else{
              return ({...children,
                amount: Number( children?.quantity * item.amount || item.amount ),
                itemNumber:itemCount,
                configuredacc:item.bom?item.bom?.any(b=> b?.name==children.name):false,
                VATlistPrice:this.props.prices[children.name]?.listPrice*siteSettings?.properties?.priceFactor
              })
            }
              });
 
            }}
            if ( item.looseadditionalProduct && item.looseadditionalProduct.length>0 ) {
            const lang = getLanguages().first();
            const accessories = item.looseadditionalProduct[0].configuration && deflateModelVariables( item.looseadditionalProduct[0].configuration.model );
            const filteredAccessories = accessories.filter( accessory =>
              assignmentDecision( item.looseadditionalProduct[0].configuration.productModelType, lang )( accessory ) &&
              getAssignedValue( accessory ) !== item.looseadditionalProduct[0].configuration.product.name )
              .map( ( accessory ) => {if(item.bom && item.bom?.any(b=> b?.name==accessory?.assignedValue?.name)){
                return ( {
                  ...products[accessory.assignedValue.name] || { ...accessory.assignedValue, code: accessory.assignedValue.name },
                  amount: accessory?.quantity ?? accessory.assignedValue.quantity ?? ( item.amount || 1),
                  materialCorrection: materialCorrection,
                  listPrice:this.props.prices[accessory.assignedValue.name]?.listPrice,
                  itemNumber:itemCount,
                  priceUnit: 1,
                  configuredacc:true,
                  VATlistPrice:this.props.prices[accessory.assignedValue.name]?.listPrice*siteSettings?.properties?.priceFactor,
 
                } )
              }else{
              return ( {
                ...products[accessory.assignedValue.name] || { ...accessory.assignedValue, code: accessory.assignedValue.name },
                amount: accessory?.quantity ?? accessory.assignedValue.quantity ?? ( item.amount || 1) ,
                materialCorrection: materialCorrection,
                listPrice:this.props.prices[accessory.assignedValue.name]?.listPrice,
                itemNumber:itemCount,
                priceUnit: 1,
                VATlistPrice:this.props.prices[accessory.assignedValue.name]?.listPrice*siteSettings?.properties?.priceFactor,
              } )}}
              );
            if ( filteredAccessories ) {
             // filteredAccessories.forEach( acc => item.children.push( {...acc,properties:[]} ) ) //SDDC-1281 fix
             filteredAccessories.forEach( acc => !item.children.find(i=> i.code === acc.code) && item.children.push( {...acc,properties:[]} ) )
 
            }    
      item={...item,looseadditionalProduct:[]}
            }
        }
          item.children.map((children) =>{children.description =  getProductDescription(children),children.properties=[]} );
          //DummyCode for Half Kit Terminal
          let assignedValueCount = 0;
          let variableName = null;
          let assignedId = null;
         // if (item?.materialName != "EMAX2_E1") { //Tmax
          if(item?.materialName?.startsWith('TMAX')){
            item?.configuration?.model?.children.forEach(val => {
              let count = 0
              for (const i in val?.variables) {
                if (val.variables[i]?.name == ("SEMI_TERM_INF") || val.variables[i]?.name == ("SEMI_TERM_SUP")) {
                  count++;
                  if (val.variables[i].assignedValue) {
                    assignedValueCount += 1;
 
                    if (assignedValueCount == 1) {
                      variableName = val.variables[i]?.name;
                      assignedId = val.variables[i]?.assignedValue.name;
                    }
 
 
 
 
                  }
                  if (count == 2) { break }
                }
              }
            })
          }
          if (assignedValueCount == 1) {
            const element = { ...item };
            const itemId = element?.children.findIndex(elementValue => elementValue?.name == assignedId);
 
            if (variableName == "SEMI_TERM_INF") {
              if (itemId > -1) {
                element?.children.splice(itemId, 0, { code: "1SDA050230R1", name: "1SDA050230R1", aBBID: "1SDA050230R1", description: getProductDescription("1SDA050230R1"), amount: 1 })
              }
              //element?.children?.unshift({code:"1SDA050230R1",name:"1SDA050230R1",description:getProductDescription("1SDA050230R1"),quantity:0})
              return element;
            }
            else {
 
              if (itemId > -1) {
                element?.children.splice(itemId + 1, 0, { code: "1SDA050230R1", name: "1SDA050230R1", aBBID: "1SDA050230R1", description: getProductDescription("1SDA050230R1"), amount: 1 })
 
              }
 
 
 
              //element?.children?.push({code:"1SDA050230R1",name:"1SDA050230R1",description:getProductDescription("1SDA050230R1"),quantity:0})
              return element;
            }
 
 
          }
          return item;
        }).map( i => this.getProduct( i, isReadyAssembled ) );
        this.busy = true;
        this.setState({isBusy:true});
        if(( cartItems[0]?.isReadyAssembled ||cartItems[0]?.superCode)&& user.country == siteSettings?.properties?.userCountry ){
          if ( siteSettings.currencyBasedExport ) {
            this.props.customExport( 'xlsx', Object.values( exportItemsXLS ), `Template_${ currency }`,
              `Template.xlsx`, "" );
          } else{
            this.props.customExport( 'xlsx', Object.values( exportItemsXLS ), 'Template_RA')
          }
        }
        else{
          if ( exportItemsXLS.length > 0 && isReadyAssembled && user.country == siteSettings.properties.userCountry ) {
 
            exportItemsXLS.map( v => {
              var calculateChildAmount = 0;
              if ( v.children && ( v?.superCode != undefined || v?.superCode != null ) ) {
                v.children.forEach( a => {
                  calculateChildAmount += a.listPrice;
                } )
                v.listPrice = v.listPrice + calculateChildAmount;
                v.netPrice = v.netPrice + calculateChildAmount;
              }
            } );
            let exportvalue = exportItemsXLS;
            exportvalue.forEach( v => {
              if ( v?.superCode != undefined || v?.superCode != null ) {
                if ( v?.superCode ) {
                  v.name = v.superCode;
                   v.description = v.description.toString().replaceAll( ',', '\r\n' );
                  //v.description = v.description.toString();
                }
                v.children = [];
              }
 
            } );
          }
        if(customExportTemplate && user.authenticationType == "Apttus"){
          this.props.customExport( 'xlsx', Object.values( exportItemsXLS ), `${customExportTemplate}_${currency}`,
          `${ customExportTemplate }.xlsx`, "" );
        }
        else if ((siteSettings.showCbolXlsx && type == "Excel for CBOL")) {
          this.props.customExport('xlsx', Object.values(exportItemsXLS), `${customExportTemplate}_CBOL`,
            `${customExportTemplate}.xlsx`, "");
        }
        else if (customExportTemplate) {
          this.props.customExport('xlsx', Object.values(exportItemsXLS), `${customExportTemplate}`,
            `${customExportTemplate}.xlsx`, "");
        }
        else if (siteSettings.currencyBasedExport) {
          this.props.customExport('xlsx', Object.values(exportItemsXLS), `Template_${currency}`,
            `Template.xlsx`, "");
        }
        else {
          await this.props.exportType(type, exportItemsXLS);
        }}
        this.busy = false;
        this.setState({isBusy:false});
      }else if(exportFileTypes[type] && type === 'pdf'){
        const exportItems = cartItems.map((item) => {
          if ( siteSettings.createSupercodeInSap && item.superCode != undefined && isReadyAssembled && user.country ==siteSettings.properties.userCountry ) {
            const accessories = getAccessories( item );
            item.children = accessories.map( ( accessoryCode ) => products[accessoryCode] ).map( this.getProduct );
            item.description = getProductDescription( item, isReadyAssembled );
            return item;
          }
          else{
          item.description = getProductDescription(item);
          if (item.configuration && item.configuration.bomComponents && item.configuration.bomComponents.length) {
            let bomDetails = [];
 
            item.configuration.bomComponents.forEach((c) => {
              if (products[c.component]) {
                bomDetails.push(products[c.component]);
              } else {
                const wiringDiagamDetails = {
                  code: c.component,
                  itemID: c.itemID,
                  itemNumber: c.itemNumber
                }
                bomDetails.push(wiringDiagamDetails);
              }
            });
 
            item.children = bomDetails.map(c => c).map(this.getProduct);
 
            item.children = item.children.map(children => {
              return {
                ...children,
 
 
                amount: Number(item.configuration.bomComponents.filter(bom => bom.component == children.code && bom.quantity)
                  .firstOrDefault()?.quantity * item.amount || item.amount || 1)
              }
            });
 
 
          } else {
            item.children = getAccessories(item).map((accessoryCode) => products[accessoryCode]).map(this.getProduct);
            const missingBomItems = item.configuration && item.configuration.assignments.filter(assign => assign.key === null)
              .map(c => products[c.value]).map(this.getProduct);
            missingBomItems && missingBomItems.forEach(bomItem => {
              item.children.push(bomItem);
            })
            // Adding the quantity from the import accessories if the item is imported and not configured or if configured
            // then updating the quantity from main product amount
            if (item.importAccessories && item.importAccessories.length > 0) {
              item.children = item.children.map(children => ({
                ...children,
 
                amount: Number(item.importAccessories.find(acc => acc.accessoryCode === children.code)?.quantity) || 0
              }))
 
                .filter(c => c.amount > 0);
            } else {
              item.children = item.children.map(children => ({
                ...children,
 
                amount: Number(children?.quantity * item.amount || item.amount)
              }));
 
            }
          }
          item.children.map((children) => children.description = getProductDescription(children));
 
          //DummyCode for Half Kit Terminal
          let assignedValueCount = 0;
          let variableName = null;
          let assignedId = null;
          if (item?.materialName != "EMAX2_E1") {
            item?.configuration?.model?.children.forEach(val => {
              let count = 0
              //val?.variables.forEach
              //Find the assigned value ID  and also checking if the it is upper / lower Terminal
              for (const i in val?.variables) {
                if (val.variables[i]?.name == ("SEMI_TERM_INF") || val.variables[i]?.name == ("SEMI_TERM_SUP")) {
                  count++;
                  if (val.variables[i].assignedValue) {
                    assignedValueCount += 1;
                    if (assignedValueCount == 1) {
                      variableName = val.variables[i]?.name;
 
                      assignedId = val.variables[i]?.assignedValue.name;
                    }
                  }
                  if (count == 2) { break }
                }
              }
            })
          }
 
          if (assignedValueCount == 1) {
            const element = { ...item };
            const itemId = element?.children.findIndex(elementValue => elementValue?.name == assignedId);
 
            if (variableName == "SEMI_TERM_INF") {
              if (itemId > -1) {
                element?.children.splice(itemId, 0, { code: "1SDA050230R1", name: "1SDA050230R1", aBBID: "1SDA050230R1", description: getProductDescription("1SDA050230R1"), amount: 1 })
              }
              return element;
            }
            else {
 
              if (itemId > -1) {
                element?.children.splice(itemId + 1, 0, { code: "1SDA050230R1", name: "1SDA050230R1", aBBID: "1SDA050230R1", description: getProductDescription("1SDA050230R1"), amount: 1 })
              }
              return element;
            }
 
          }
          return item;}
        }).map( i => this.getProduct( i, isReadyAssembled ) );
 
        this.busy = true;
        this.setState({isBusy:true});
        if ( exportItems.length > 0 && isReadyAssembled && user.authenticationType == 'Cbol' && user.country == siteSettings.properties.userCountry ) {
          exportItems.map( pdfValue => {
            var calculateChildAmount = 0;
            if ( pdfValue.children && ( pdfValue?.superCode != undefined || pdfValue?.superCode != null ) ) {
              pdfValue.children.forEach( a => {
                calculateChildAmount += a.listPrice;
              } )
              pdfValue.listPrice = pdfValue.listPrice + calculateChildAmount;
              pdfValue.netPrice = pdfValue.netPrice + calculateChildAmount;
            }
          } );
          let exportPdfValue = exportItems;
          exportPdfValue.forEach( v => {
            if ( v?.superCode != undefined || v?.superCode != null ) {
              if ( v?.superCode ) {
                v.code = v.superCode;
                v.description = v.description.toString().replaceAll( ',', '\n' );
              }
              v.children = [];
            }
          } );
        }
       
        if( customExportTemplate ){
          exportItems[0].userName=user.username;
          exportItems[0].cartId=user.properties.CartID
          this.props.customExport( 'pdf', Object.values( exportItems ), `${customExportTemplate}_${currency}`,
          `${ customExportTemplate }.pdf`, "" );
        }
        else if (siteSettings.currencyBasedExport) {
          this.props.customExport('pdf', Object.values(exportItems), `Template_${currency}`,
            `Template.pdf`, "");
        }
        else {
          await this.props.exportType(type, exportItems);
        }
        this.busy = false;
        this.setState({isBusy:false});
      }
      else if (exportFileTypes[type] && type === "Export Tender Text") {
        const productList = [];
        cartItems.forEach(item => {
          productList.push(item.code);
          if (item.configuration && item.configuration.bomComponents && item.configuration.bomComponents.length) {
            item.children = item.configuration.bomComponents.filter(bom => products[bom.component] !== null &&
              products[bom.component] !== undefined).map(c => products[c.component]).map(this.getProduct);
          } else {
            item.children = getAccessories( item ).map( ( accessoryCode ) => products[accessoryCode] ).map( this.getProduct );
            const missingBomItems = item.configuration && item.configuration.assignments.filter( assign => assign.key === null )
              .map( c => products[c.value] ).map( this.getProduct );
            missingBomItems && missingBomItems.forEach( bomItem => {
              item.children.push( bomItem );
            } )
          }
          item.children.forEach( childItem => {
            productList.push( childItem.code );
          } );
          //productList.push(item.children);
        });
        const tenderTextUrlParts = siteSettings.tenderTextUrl.split('productList');
        const tenderTextUrl = tenderTextUrlParts[0] + productList + tenderTextUrlParts[1] + this.state.tenderText;
        window.open(tenderTextUrl);
      }
      this.busy = false;
      this.setState({isBusy:false});
      this.props.onClose()
    }
  }
  selectType = ( e ) => this.props.selectType( e.target.value );
 
 
 
  handleTenderText = (e) => {
    switch (e) {
      case "GAEB XML: Universelle LV-Daten (X80)":
        this.setState({ tenderText: "100" })
        break;
      case "GAEB XML: Leistungsverzeichnis (X81)":
        this.setState({ tenderText: "101" })
        break;
      case "GAEB XML: Kostenanschlag (X82) - inkl. Preise":
        this.setState({ tenderText: "102" })
        break;
      case "GAEB XML: Angebotsaufforderung (X83)":
        this.setState({ tenderText: "103" })
        break;
      case "GAEB 90: Leistungsverzeichnis (D81)":
        this.setState({ tenderText: "110" })
        break;
      case "GAEB 90: Kostenanschlag (D82) - inkl. Preise":
        this.setState({ tenderText: "111" })
        break;
      case "GAEB 90: Angebotsaufforderung (D83)":
        this.setState({ tenderText: "112" })
        break;
      case "ÖNORM: A2063-Datei im Format „Ausschreibungs-LV'":
        this.setState({ tenderText: "130" })
        break;
      case "ÖNORM: A2063-Datei im Format „Kostenschätzungs-LV'":
        this.setState({ tenderText: "131" })
        break;
      case "Excel":
        this.setState({ tenderText: "20" })
        break;
      case "Word":
        this.setState({ tenderText: "10" })
        break;
      case "Textdatei (.txt)":
        this.setState({ tenderText: "50" })
        break;
      case "Formatierter Text (.rtf)":
        this.setState({ tenderText: "30" })
        break;
    }
  };
 
 
  hidePopup = () => this.props.hidePopup();
 
 
 
  render() {
    let { loading, checkBox } = this.state;
    let checkboxes;
    if (loading) {
      return null;
    }
    const { exportFileTypes, siteSettings,user } = this.props;
    const fromCbol = user.authenticationType === 'Cbol';
    if (siteSettings.showXlsxForCbol && !Object.keys(exportFileTypes).includes("Excel for CBOL")) {
      const cbolExportFileTypes = { "Excel for CBOL": false };
      checkboxes = Object.keys(exportFileTypes).map(type =>
        <Checkbox key={type}
          title={translate(type.toUpperCase())}
          checked={exportFileTypes[type]}
          value={type} onChange={this.selectType} />);
      let cbolCheckbox = Object.keys(cbolExportFileTypes).map(type =>
        <Checkbox key={type}
          title={translate(type.toUpperCase())}
          checked={exportFileTypes[type]}
          value={type}
          onChange={this.selectType} />);
      checkboxes.push(cbolCheckbox);
    } else {
      checkboxes = Object.keys(exportFileTypes).map(type =>
      type!="pdf" && <Checkbox key={ type }
          title={translate(type.toUpperCase())}
          checked={exportFileTypes[type]}
          value={type} onChange={this.selectType} />);
    }
 
    if (siteSettings.exportTenderText && !Object.keys(exportFileTypes).includes("Export Tender Text")) {
      const tenderTextExportType = { "Export Tender Text": false };
      checkboxes = Object.keys(exportFileTypes).map(type =>
        <Checkbox key={type}
          title={translate(type.toUpperCase())}
          checked={exportFileTypes[type]}
          value={type} onChange={this.selectType} />);
      let tenderTextCheckBox = Object.keys(tenderTextExportType).map(type =>
        <Checkbox key={type}
          title={translate(type.toUpperCase())}
          checked={exportFileTypes[type]}
          value={type} onChange={this.selectType} />);
      checkboxes.push(tenderTextCheckBox);
    }
 
 
    return <div className="export-cart-panel" >
      <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.props.onClose} sx={{position:"absolute", top:"12px", right:"12px", background:"#F5F5F5",width:{md:"24px", xs:"18px"}, height:{md:"24px", xs:"18px"}, borderRadius:"56px" , backgroundColor: 'white'}}>
              <Box component="img" src={closePopup} style={{width: 'inherit', height: 'inherit'}} sx={{height:"24px", width:"24px"}}></Box>
      </MuiIconButton>
      <div className="export-cart-header">
        <span>{fromCbol?translate("export configuration bom"):translate("export wishlist")}</span>
      </div>
      <div className="export-file-types" >
        <h5>{ translate( 'Select format:' ) }</h5>
        { checkboxes }
      </div>
      <h5>{translate('Select file extension')}</h5>
        {siteSettings.exportTenderText &&
          <DropdownList
            style={{ width: '100%' }}
            filter="contains"
            data={["GAEB XML: Universelle LV-Daten (X80)", "GAEB XML: Leistungsverzeichnis (X81)", "GAEB XML: Kostenanschlag (X82) - inkl. Preise", "GAEB XML: Angebotsaufforderung (X83)", "GAEB 90: Leistungsverzeichnis (D81)", "GAEB 90: Kostenanschlag (D82) - inkl. Preise", "GAEB 90: Angebotsaufforderung (D83)", "ÖNORM: A2063-Datei im Format „Ausschreibungs-LV'", "ÖNORM: A2063-Datei im Format „Kostenschätzungs-LV'", "Excel", "Word", "Textdatei (.txt)", "Formatierter Text (.rtf)"]}
            placeholder={'-- select format --'}
            defaultValue="Word"
            onChange={this.handleTenderText}
          />}
      <div className="actions" >
      <div className={classNames('primary-button',{"disabled":Object.values( exportFileTypes ).none( value => value ), "isBusy":this.state.isBusy })} onClick={ this.onExport }>
          {!this.state.isBusy?<span className={Object.values( exportFileTypes ).none( value => value ) ? 'disable-export': ''}>{ translate( 'Export' ) }</span>:
          <BusyContainer isBusy={this.state.isBusy} position="relative" top="0px" left="0px" height="100%" size={24}></BusyContainer>}
        </div>
        <IconButton className="tertiary-button cancel-btn" text={ translate( 'Cancel' ) } onClick={ this.props.onClose } />
        {/* <div disabled={ Object.values( exportFileTypes ).none( value => value ) }
          className="primary-button" text={ translate( 'Export' ) } onClick={ this.onExport } /> */}
         
       
  </div>
        {/* from mainmerge */}
        {/* <h5>{translate('Select file extension')}</h5>
        {checkboxes}
        {siteSettings.exportTenderText &&
          <DropdownList
            style={{ width: '100%' }}
            filter="contains"
            data={["GAEB XML: Universelle LV-Daten (X80)", "GAEB XML: Leistungsverzeichnis (X81)", "GAEB XML: Kostenanschlag (X82) - inkl. Preise", "GAEB XML: Angebotsaufforderung (X83)", "GAEB 90: Leistungsverzeichnis (D81)", "GAEB 90: Kostenanschlag (D82) - inkl. Preise", "GAEB 90: Angebotsaufforderung (D83)", "ÖNORM: A2063-Datei im Format „Ausschreibungs-LV'", "ÖNORM: A2063-Datei im Format „Kostenschätzungs-LV'", "Excel", "Word", "Textdatei (.txt)", "Formatierter Text (.rtf)"]}
            placeholder={'-- select format --'}
            defaultValue="Word"
            onChange={this.handleTenderText}
          />}
      </div>
      <div className="actions" >
        <IconButton text={translate('Cancel')} onClick={this.hidePopup} />
        <IconButton disabled={Object.values(exportFileTypes).none(value => value)}
          className="blue-button" text={translate('Export')} onClick={this.onExport} />
 
      </div> */}
    </div>;
  }
}
 
ExportCartPanelComponent.propTypes = {
  cartItems: PropTypes.arrayOf(PropTypes.shape({})),
  products: PropTypes.arrayOf(PropTypes.shape({})),
  exportFileTypes: PropTypes.shape({}),
  exportType: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  hidePopup: PropTypes.func.isRequired,
  selectType: PropTypes.func.isRequired
};
 
export const ExportCartPanel = connect(combineStates(exportState, productState, priceState, identityState,
  currentNodeState, siteSettingsState,cartState),
  combineDispatchers(exportDispatcher, productsDispatcher))
  (ExportCartPanelComponent);
 